module.exports = ".tableRow i {\r\n    font-size: 11px;\r\n}\r\n\r\n.btn {\r\n    margin-left: 5px;\r\n}"